/**
 * 从URL中提取域名
 * @param {string} url 完整的URL
 * @returns {string} 域名
 */
function extractDomain(url) {
  try {
    const urlObj = new URL(url);
    return urlObj.hostname;
  } catch (e) {
    return url;
  }
}

/**
 * 获取网站图标的URL
 * @param {string} url 网站URL
 * @returns {string[]} 可能的图标URL数组，按优先级排序
 */
export function getFaviconUrls(url) {
  const domain = extractDomain(url);
  return [
    // 首选：Google 的 favicon 服务
    `https://www.google.com/s2/favicons?domain=${domain}&sz=64`,
    // 备选：网站根目录的标准位置
    `https://${domain}/favicon.ico`,
    `https://${domain}/favicon.png`,
    // 如果都失败了，使用默认图标
    '/favicon.png'
  ];
}

/**
 * 检查图片URL是否可访问
 * @param {string} url 图片URL
 * @returns {Promise<boolean>} 是否可访问
 */
export function checkImageExists(url) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve(true);
    img.onerror = () => resolve(false);
    img.src = url;
  });
}

/**
 * 获取第一个可用的网站图标
 * @param {string} url 网站URL
 * @returns {Promise<string>} 可用的图标URL
 */
export async function getFavicon(url) {
  const iconUrls = getFaviconUrls(url);
  
  // 首先尝试 Google 的 favicon 服务，它几乎总是可用的
  return iconUrls[0];
  
  // 如果需要故障转移，可以取消下面的注释
  /*
  for (const iconUrl of iconUrls) {
    if (await checkImageExists(iconUrl)) {
      return iconUrl;
    }
  }
  return iconUrls[iconUrls.length - 1]; // 返回默认图标
  */
} 